var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('img',{attrs:{"src":_vm.logo[_vm.type],"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }